import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
interface IFooterItemsProps {
    icon: string | undefined
    isActive: boolean
    title: string
    router: string
    role: string
    activeIcon: string
}

const Items = ({
    icon,
    isActive,
    title,
    router,
    role,
    activeIcon,
}: IFooterItemsProps) => {
    const navigate = useNavigate()
    return (
        <>
            <div
                onClick={() => navigate(router)}
                className={classNames(
                    'm-auto  text-center items-center cursor-pointer '
                )}
            >
                <img
                    src={isActive ? activeIcon : icon}
                    alt="home"
                    className={classNames(' mx-auto', 'w-7 h-7')}
                />
                <small
                    className={classNames(
                        ' font-extrabold  mt-2 text-center',
                        isActive ? 'text-current' : 'text-gray-1'
                    )}
                >
                    {title}
                </small>
            </div>
        </>
    )
}

export default Items
